import { useEffect } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, ShoppingBag, Package, Ticket, Users, ArrowLeft, Layers, Sparkles, FileText, ScanLine } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/categories", label: "Categories", icon: Layers },
  { to: "/admin/occasions", label: "Occasions", icon: Sparkles },
  { to: "/admin/content", label: "Site Content", icon: FileText },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket },
  { to: "/admin/customers", label: "Customers", icon: Users },
];

export default function AdminLayout() {
  const { user, ready } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && (!user || user.role !== "admin")) navigate("/auth?redirect=/admin");
  }, [ready, user]);

  if (!user || user.role !== "admin") {
    return <div className="pt-40 pb-40 text-center font-serif text-3xl bg-white min-h-screen">Verifying access…</div>;
  }

  return (
    <div className="min-h-screen bg-white text-ink flex" data-testid="admin-layout">
      <aside className="w-60 shrink-0 border-r border-line min-h-screen sticky top-0 flex flex-col">
        <div className="p-6 border-b border-line">
          <Link to="/" className="block">
            <img src="/ambrai-logo.png" alt="Amraiya" className="h-16 w-auto" />
          </Link>
          <p className="mono text-[0.6rem] text-ink-soft mt-2">ADMIN CONSOLE</p>
          <Link
            to="/pos"
            className="mt-4 flex items-center justify-center gap-2 rounded-md bg-ink text-ivory text-sm font-medium py-2.5 hover:bg-black transition-colors"
            data-testid="admin-open-pos"
          >
            <ScanLine size={16} /> Open POS
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                  isActive ? "bg-ink text-ivory" : "text-ink-soft hover:bg-black/[0.04]"
                }`
              }
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
            >
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/" className="flex items-center gap-2 p-6 text-sm text-ink-soft hover:text-ink border-t border-line">
          <ArrowLeft size={15} /> Back to store
        </Link>
      </aside>

      <main className="flex-1 min-w-0 p-8 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
